export default __webpack_public_path__ + "static/media/package4.16f15ee5.jpg";